<!-- Notification Bell Icon & Counter -->
<div class="notification-container">
  <!-- Notification Bell Button -->

  <!-- Connection Status Indicators -->
  <!-- <div class="connection-status" [ngClass]="getConnectionStatusClass()">
  <svg *ngIf="connectionStatus === 'connected'" width="8" height="8" viewBox="0 0 8 8">
    <circle cx="4" cy="4" r="4" fill="#10b981"/>
  </svg>
  <svg *ngIf="connectionStatus === 'connecting'" width="8" height="8" viewBox="0 0 8 8">
    <circle cx="4" cy="4" r="4" fill="#f59e0b"/>
  </svg>
  <svg *ngIf="connectionStatus === 'disconnected'" width="8" height="8" viewBox="0 0 8 8">
    <circle cx="4" cy="4" r="4" fill="#ef4444"/>
  </svg>
</div> -->

<!-- Notifications Dropdown -->
@if (showNotifications) {
  <div
    class="notifications-dropdown"
    [class.show]="showNotifications"
    >
    <!-- Header -->
    <div class="notifications-header">
      <h5 class="text-white">Notifications</h5>
      <div class="header-actions">
        <span class="notification-count">{{ notificationCount }} notifications</span>
        @if (notificationCount > 0) {
          <button class="clear-all-btn" (click)="clearAllNotifications()">
            Clear All
          </button>
        }
      </div>
    </div>
    <!-- Notifications List -->
    @if (notifications.length > 0) {
      <div class="notifications-list">
        <!-- Update your alert card content section to display the parsed information -->
        @for (notification of notifications; track trackByNotificationId($index, notification)) {
          <div
            class="alert-card"
            [ngClass]="getAlertCardClass(notification)"
            (click)="onNotificationClick(notification.id)">
            <!-- <div class="alert-icon-left"><i ng-class="icon" aria-hidden="true" class="fa fa-exclamation fa-x"></i></div>  -->
            <!-- Alert Content -->
            <div class="alert-content">
              <!-- Alert Name -->
              <div class="alert-title">
                {{ getAlertName(notification) }}
              </div>
              <!-- Alert Description -->
              @if (getAlertDescriptionParsed(notification) !== 'No description available') {
                <div class="alert-description">
                  {{ getAlertDescriptionParsed(notification) }}
                </div>
              }
              <!-- Alert Created -->
              @if (getAlertCreated(notification) !== 'Not specified') {
                <div class="alert-created">
                  {{ formatFullTimestamp(getAlertCreated(notification)) }}
                </div>
              }
              <!-- Alert Updated -->
              <!-- <div class="alert-updated" *ngIf="getAlertCreated(notification) !== 'Not specified'">
              {{ getAlertCreated(notification) }}
            </div> -->
            <!-- Alert Timestamp (when notification was received) -->
            <!-- <div class="alert-timestamp">
            {{ formatFullTimestamp(notification.timestamp) }}
          </div> -->
        </div>
        <!-- Alert Actions -->
        <div class="alert-actions" (click)="$event.stopPropagation()">
          <!-- Go Live Button -->
          <!-- <button
          *ngIf="hasGoLiveAction(notification)"
          class="alert-action-btn go-live-btn"
          (click)="goLiveToEvent(notification.id)"
          title="Go Live">
          ✏️
        </button> -->
        <!-- Dismiss Button -->
        <button
          class="alert-action-btn dismiss-btn"
          (click)="dismissNotification(notification.id)"
          title="Dismiss">
          <i class="fa fa-bell-slash text-white"></i>
        </button>
        @if (hasGoLiveAction(notification) && getNotificationStatus(notification) !== 'PENDING') {
          <button
            class="alert-action-btn go-live-btn"
            (click)="goLiveIncident(notification)"
            title="Go Live">
            🌐
          </button>
        }
      </div>
    </div>
  }
</div>
} @else {
  <div class="no-notifications">
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
      <path d="M2 2L22 22"></path>
    </svg>
    <p>No notifications</p>
  </div>
}
<!-- No Notifications State -->
</div>
}
</div>

<!-- Backdrop for closing dropdown when clicking outside -->
<!-- <div
*ngIf="showNotifications"
class="notification-backdrop"
(click)="closeNotifications()">
</div> -->

<!-- //PIN Activition-->

<div class="modal fade" tabindex="-1" [ngClass]="{ 'show d-block': showPinDialog }"
  [ngStyle]="{ 'display': showPinDialog ? 'block' : 'none' }" role="dialog" aria-modal="true">
  <div class="modal-dialog modal-md  modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">Pin Verify</h5>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="onPinDialogClosed(false)"></button>
      </div>
      <div class="modal-body">
        <div class="pin-wrapper">
          <app-pin-keypad [(pinValue)]="pinValue" (close)="onPinDialogClosed($event)"></app-pin-keypad>

          <div class="d-flex justify-content-center gap-2 mt-3">
            <button class="btn btn-danger btn-lightning" (click)="confirmPublicIncident(notifications)">Activate And Go</button>
            <button class="btn btn-secondary" data-bs-dismiss="modal" (click)="onPinDialogClosed(false)">Cancel</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

